function createPromiseActionsMiddleware(extraArgument) {
  return ({ dispatch, getState }) => next => action => {
    if (action && action.payload && typeof action.payload === 'function') {
      let result = action.payload(dispatch, getState);
      if (result && result.then) {
        return result.then(promiseResult => {
          if (promiseResult) {
            action.payload = promiseResult.preventPromiseAction ? promiseResult.data : promiseResult;
            if(!promiseResult.preventPromiseAction) {
              next(action);
            }
            return promiseResult;
          }
        });
      } else if (result) {
        action.payload = result;
        return next(action);
      }
    } else {
      return next(action);
    }
  };
}

const promiseActions = createPromiseActionsMiddleware();
promiseActions.withExtraArgument = createPromiseActionsMiddleware;

export default promiseActions;
